<div class="prompt-text">
  <div class="prompt-text__input-wrapper" #inputWrapper>
    <brt-input-text [data]="{label: label, id: '-1', placeholder: '', value: ''}" (onValueChange)="currentValue = $event"></brt-input-text>
  </div>

  <div class="prompt-text__actions">
    <div class="prompt-text__action" (click)="onCancelClicked()">
      <brt-button [title]="'Abbrechen'" color="transparent"></brt-button>
    </div>
    <div class="prompt-text__action" (click)="confirm()">
      <brt-button [title]="'Speichern'" color="river" [disabled]="currentValue.length < minLength"></brt-button>
    </div>
  </div>
</div>
